<template>
    <kendo-window ref="container" @close="onClose" :visible="true" :width="320">
        <form class="form form-vue">
            <fieldset>
                <section class="form-group">
                    <kendo-dropdown
                        :value="selectedType"
                        @input="input => selectedType = input.value"
                        :label="i18n('Common.Type')"
                        :dataSource="typeDataSource">
                    </kendo-dropdown>
                </section>
                <section>
                    <download-customers-retention
                        v-if="selectedType === 0"
                        ref="context">
                    </download-customers-retention>
                    <download-group-market-share
                        v-if="selectedType === 1"
                        ref="context">
                    </download-group-market-share>
                </section>
            </fieldset>
            <fieldset>
                <section>
                    <div class="text-right">
                        <button class="btn" @click.prevent="onClose">{{ i18n('Action.Close') }}</button>
                        <button class="btn btn-info" @click.prevent="onSubmit">{{ i18n('Action.Download') }}</button>
                    </div>
                </section>
            </fieldset>
        </form>
    </kendo-window>
</template>

<script>
import KendoWindow from '../../../shared/components/kendo-window/kendo-window.component';
import KendoDropdown from '../../../shared/components/kendo-dropdown/kendo-dropdown.component';
import DownloadCustomersRetention from '../../components/download-customers-retention/download-customers-retention.component';
import DownloadGroupMarketShare from '../../components/download-group-market-share/download-group-market-share.component';

import { i18nMixin } from '../../../shared/mixins';

export default {
    name: 'download-window',

    props: {},

    computed: {},

    data () {
        return {
            visible: false,
            typeDataSource: [{
                text: this.i18n('Report.RetentionDataExtract'),
                value: 0
            // }, {
            //     text: 'Report.GroupMarketShare',
            //     value: 1
            }],
            selectedType: 0
        };
    },

    mixins: [i18nMixin],

    methods: {
        onClose () {
            if (this.visible) {
                this.visible = false;
                this.$refs.container.close();
            }
        },
        onSubmit () {
            this.$refs.context.saveAsExcel();
        }
    },

    mounted () {
        this.visible = true;
    },

    components: {
        KendoDropdown,
        KendoWindow,
        DownloadCustomersRetention,
        DownloadGroupMarketShare
    }
};
</script>

<style lang="scss" scoped>
    .form {
        padding: 0.5rem 0.5rem 0.25rem;
    }
</style>



// WEBPACK FOOTER //
// src/modules/download/containers/download-window/download-window.container.vue